import React from "react";
// @material-ui/core components
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

import Email from "@material-ui/icons/Email";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import axios from "../../utils/axiosInstance"; 
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyles = makeStyles(styles);
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { CircularProgress } from "@material-ui/core";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);
export default function ForgetPassword() {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loginEmailState, setregisterEmailState] = React.useState("");
  const [alert, setAlert] = React.useState(null);
  const [loading, setLoading] = useState(false); 
  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };

  const validateEmail = (email) => {
    return email.match();
  };

  const hideAlert = () => {
    setAlert(null);
    window.location.assign("/auth/login-page");
  };

  const handleClick = async (e) => {
    e.preventDefault();
    let payload = {
      email: email,
    };
    if (validateEmail(email)) {
      setLoading(true);
      await axios
        .post(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/forgotpassword`,
          payload
        )
        .then((response) => {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {response.data.message}
                </span>
              }
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              titleCssClass={classesSweetAlert.cardTitle}
              confirmBtnCssClass={
                classesSweetAlert.button + " " + classesSweetAlert.success
              }
            />
          );
         
        }) .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          setLoading(false); 
        });
    } else {
      alert("Please provide valid email!!");
      if (email != "") {
        if (validateEmail(email) == null) {
          setError("Please Enter Valid Email Address");
          console.log(error.error);
        }
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.type === "email" && verifyEmail(e.target.value)) {
      setEmail(e.target.value);
      setregisterEmailState("success");
    } else {
      setregisterEmailState("error");
    }
  };

  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={4}>
          <form onSubmit={handleClick}>
            <Card login className={classes[cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="rose"
              >
                <h4 className={classes.cardTitle}>Forget Password</h4>
                <div className={classes.socialLine}>
                  {[
                    "fab fa-facebook-square",
                    "fab fa-twitter",
                    "fab fa-google-plus",
                  ].map((prop, key) => {
                    return (
                      <Button
                        color="transparent"
                        justIcon
                        key={key}
                        className={classes.customButtonClass}
                      >
                        <i className={prop} />
                      </Button>
                    );
                  })}
                </div>
              </CardHeader>
              <CardBody>
                <CustomInput
                  labelText="Email..."
                  id="email"
                  success={loginEmailState === "success"}
                  error={loginEmailState === "error"}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  handleChange={handleChange}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Email className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    ),
                    type: "email",
                  }}
                />
              </CardBody>
              <CardFooter className={classes.justifyContentCenter}>
              {!loading ? (
                <Button
                  style={{ marginLeft: 120 }}
                  type="submit"
                  color="rose"
                  size="lg"
                  block
                >
                  Let{"'"}s Go
                </Button>
) : (
  <div style={{ marginLeft: 145 }}>
    <CircularProgress sx={{marginLeft:"10px"}} />
  </div>
)}
                <Button
                  style={{ marginLeft: -97, marginTop: -80 }}
                  color="rose"
                  simple
                  size="lg"
                  block
                  onClick={() => window.location.assign("/auth/login-page")}
                >
                  Login
                </Button>
                {alert}
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
